// Blog / comparison / pillar content registry.
// Pure ES module: consumed by the React app (webpack) AND by scripts/prerender.js
// via dynamic `await import()` (Node treats .mjs as ESM natively).

import semanticLayerGuide from "./entries/semantic-layer-guide.mjs";
import whatIsASemanticLayer from "./entries/what-is-a-semantic-layer.mjs";
import semanticLayerVsMetricsLayerVsCatalog from "./entries/semantic-layer-vs-metrics-layer-vs-catalog.mjs";
import whyLlmsHallucinateOnData from "./entries/why-llms-hallucinate-on-data.mjs";
import textToSqlGovernance from "./entries/text-to-sql-governance.mjs";
import aiDataGovernanceFramework from "./entries/ai-data-governance-framework.mjs";
import whySelfServiceAnalyticsFails from "./entries/why-self-service-analytics-fails.mjs";
import businessGlossaryGuide from "./entries/business-glossary-guide.mjs";
import piiMaskingAiAnalytics from "./entries/pii-masking-ai-analytics.mjs";
import semaVsDbtSemanticLayer from "./entries/sema-vs-dbt-semantic-layer.mjs";
import semaVsCube from "./entries/sema-vs-cube.mjs";
import semaVsAtscale from "./entries/sema-vs-atscale.mjs";
import semaVsLooker from "./entries/sema-vs-looker.mjs";
import whyTeamsChooseASemanticLayer from "./entries/why-teams-choose-a-semantic-layer.mjs";
import roiOfASemanticLayer from "./entries/roi-of-a-semantic-layer.mjs";
import governanceThatScalesAiAnalytics from "./entries/governance-that-scales-ai-analytics.mjs";
import insideSemaArchitecture from "./entries/inside-sema-architecture.mjs";
import beyondChatWithYourData from "./entries/beyond-chat-with-your-data.mjs";

export const POSTS = [
  semanticLayerGuide,
  whatIsASemanticLayer,
  semanticLayerVsMetricsLayerVsCatalog,
  whyLlmsHallucinateOnData,
  textToSqlGovernance,
  aiDataGovernanceFramework,
  whySelfServiceAnalyticsFails,
  businessGlossaryGuide,
  piiMaskingAiAnalytics,
  whyTeamsChooseASemanticLayer,
  roiOfASemanticLayer,
  governanceThatScalesAiAnalytics,
  insideSemaArchitecture,
  beyondChatWithYourData,
  semaVsDbtSemanticLayer,
  semaVsCube,
  semaVsAtscale,
  semaVsLooker,
].map((p) => ({
  ...p,
  image: p.image || `/blog/${p.slug}.jpg`,
  // Branded 1200x630 social card generated by the backend (og_images.py).
  ogImage: p.ogImage || `/api/og/blog/${p.slug}.png`,
}));

export function getPostByPath(pathname) {
  const clean = pathname.replace(/\/+$/, "") || "/";
  return POSTS.find((p) => p.path === clean) || null;
}

export function readingTime(post) {
  const words = post.body.split(/\s+/).length;
  return Math.max(3, Math.round(words / 220));
}
